// frontend/src/pages/public/AboutPage.jsx
import React from "react";
import Seo from "../../marketing/Seo";
import { Container, Section, Eyebrow } from "../../marketing/ui";
import { CTASection } from "../../marketing/blocks";

const VALUES = [
  { title: "Honest by default", body: "Clear limits, no per-scan fees, and no certifications we don't hold. We'd rather under-promise and over-deliver." },
  { title: "Privacy is a feature", body: "We never store raw IP addresses. You get the insight; your audience keeps their privacy." },
  { title: "Built for builders", body: "A clean API, scoped keys, and webhooks — automation is a first-class citizen, not an afterthought." },
  { title: "Do less, better", body: "A focused toolkit that does dynamic QR and analytics exceptionally well beats a bloated suite." },
];

export default function AboutPage() {
  return (
    <>
      <Seo
        title="About"
        description="QRFlow is a privacy-first, developer-friendly dynamic QR platform with honest pricing."
        path="/about"
      />

      <div className="bg-gradient-to-b from-brand-50/60 to-white">
        <Container className="py-16 sm:py-20">
          <div className="max-w-3xl">
            <Eyebrow>About QRFlow</Eyebrow>
            <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Dynamic QR, done honestly
            </h1>
            <p className="mt-5 text-lg leading-8 text-gray-600">
              QRFlow started from a simple frustration: QR platforms that meter every scan,
              cap how many codes you can make, and bury you in features you'll never use — all
              while quietly hoovering up personal data. We built the opposite.
            </p>
            <p className="mt-4 text-lg leading-8 text-gray-600">
              QRFlow gives teams generous, clearly-priced plans, a developer-friendly API, and
              real-time analytics that respect privacy by design. Change where any code points
              without reprinting, and measure what matters — without storing a single raw IP.
            </p>
          </div>
        </Container>
      </div>

      <Section muted>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900">What we value</h2>
        </div>
        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          {VALUES.map((v) => (
            <div key={v.title} className="rounded-2xl bg-white p-6 ring-1 ring-gray-200">
              <h3 className="text-lg font-semibold text-gray-900">{v.title}</h3>
              <p className="mt-2 text-sm leading-6 text-gray-600">{v.body}</p>
            </div>
          ))}
        </div>
      </Section>

      <CTASection
        title="Join us — start free today"
        subtitle="Five dynamic codes, real-time analytics, no credit card."
        primary={{ to: "/register", label: "Get started free" }}
        secondary={{ to: "/contact", label: "Get in touch" }}
      />
    </>
  );
}
